import { gql } from 'graphql-request';

export {
  resetEntitiesQuery,
  getBranchInfoQuery,
  gitDiffQuery,
  branchCommitInfoQuery,
  branchCommitInfoQueryOnlyUncommittedEntityInfo,
  commitQuery,
  projectWorkingBranchQuery,
  gitInfoQuery,
  gitSyncLagInfoQuery,
  createPRQuery,
  pullUpstreamQuery,
  pullOriginQuery,
  cleanCommitQuery,
  checkoutBranchQuery,
  branchDivergenceQuery,
  mergePRQuery,
  releaseProjectQuery,
  isProjectAdminQuery,
  deleteBranchQuery,
  cleanupGitFilesQuery,
  resetCommitQuery,
  versionsQuery,
  publishVersionQuery,
  syncAllDivergencesQuery,
  allDivergencesQuery,
  deployOrchestratorProjectMutation,
  commitDiffQuery,
  bumpVersionSuggestionsQuery,
  bumpVersionProjectQuery,
  latestVersionDetailQuery
} from '@prophecy/queries/common/queries/git';
export type {
  BranchInfoQueryType,
  CommitInfo,
  GitDiffV2QueryType,
  BranchCommitInfoQueryType,
  UnModifiedEntityInfo,
  UncommittedEntityInfo,
  DependentEntity,
  GitActionResponse,
  GitCommitResponseType,
  BranchDivergenceQueryType,
  VersionsQueryResponse,
  AllDivergencesQueryType,
  PublishVersionQueryType,
  DeployOrchestratorProjectMutationType,
  CommitDiffQueryType,
  BumpVersionSuggestionsQueryType
} from '@prophecy/queries/common/queries/git';

enum SEVERITY_TYPES {
  error = 1,
  warning = 2,
  info = 3,
  hint = 4
}

export type DiagnosticsType = {
  severity: SEVERITY_TYPES;
  message: string;
};

export type GitBranchQueryVariables = {
  projectId: string;
};
export type GitBranchQueryResponse = {
  Project: {
    isExampleProject?: boolean;
    mainBranch: string;
    listBranches: {
      workingBranch: string;
      checkedOutBranches: string[];
    };
  };
};

export const getGitBranchQuery = (remote?: boolean, stale?: boolean) => {
  let name = 'GitBranchQuery';
  let remoteField = '';
  let staleField = '';
  if (remote) {
    name = name + 'WithRemote';
    remoteField = 'remoteBranches';
  }
  if (stale) {
    name = name + 'WithStale';
    staleField = 'staleBranches';
  }
  return gql`
  query ${name}($projectId: String!) {
    Project(uid: $projectId) {
      isExampleProject
      mainBranch
      listBranches {
        workingBranch
        checkedOutBranches
        ${remoteField}
        ${staleField}
      }
    }
  }
`;
};

export type GitDiffResponse = {
  gitDiffOutput: string;
  modifiedFiles: never[];
  modifiedEntities: {
    uid: string;
    entityKind: string;
    entityName: string;
    mutationType: string;
    files: never[];
  }[];
};

export type ModifiedEntity = {
  uid: string;
  entityKind: string;
  entityName: string;
  mutationType: string;
};

export type VersionsQueryVariables = {
  projectId: string;
  excludeMergeCommits?: boolean;
};
